import { Component, OnInit } from '@angular/core';
import { SetupStructureProfitCenterStore } from '../../../../../store';
import {
	TreeService,
	UrlStoreService,
	BusinessService,
	TabStructureService,
	UserHandlerService,
	BreadcrumbService
} from '../../../../../shared/services';
import { Router } from '@angular/router';

@Component({
	selector: 'app-setup-structure-profit-center-list',
	templateUrl: './setup-structure-profit-center-list.component.html',
	styleUrls: ['./setup-structure-profit-center-list.component.scss']
})
export class SetupStructureProfitCenterListComponent implements OnInit {
	public attributes: any[] = [];
	public storeValue: string = '';
	public storeObject: any = {};
	public action: any[] = [];
	public parameters: any = {
		// // noGrid: true
		// xTypeTag: 'struct.chain'
	};

	// public detailVisible: boolean = true;
	public pctrID: string = '';
	public transactionType: string = 'all';
	fetchByStore: boolean = true;
	showDetails: boolean = false;
	setBizId: boolean = true;
	addBtn: boolean = false;
	tooltipMessage: string = 'Add Profit Center';

	public viewDetails: any[] = [
		{ header: 'Active', mapTo: 'xStatus' },
		{ header: 'Store Name', mapTo: 'xStoreName' },	
		{ header: 'Name', mapTo: 'xName' },
		{ header: 'GMID', mapTo: 'xGMID'},
		{ header: 'GMPW', mapTo: 'xGMPW'},
		{ header: 'Type Tag', mapTo: 'xTypeTag' },
		{ header: 'Tag', mapTo: 'xTag' },
		// { header: 'Medium', mapTo: 'xMdmTag' },
		// { header: 'SoP', mapTo: 'xStrVal' },
		{ header: 'Notes', mapTo: 'xNotes' },
		{ header: 'ID', mapTo: '_id' }
	];

	constructor(
		private router: Router,
		private setupStructureProfitCenterStore: SetupStructureProfitCenterStore,
		public treeService: TreeService,
		public urlStoreService: UrlStoreService,
		public businessService: BusinessService,
		private tabStructureService: TabStructureService,
		private userHandlerService: UserHandlerService,
		private breadcrumbService: BreadcrumbService
	) {
		//this.urlStoreService.swapUrl(router.url);
	}

	ngOnInit() {
		this.setBreadCrumbValue();
		this.treeService.isParent = false;
		this.tabStructureService.checkAndSetTabNameToDef(
			this.tabStructureService.tabMode,
			this.tabStructureService.isCancelClick,
			this.tabStructureService.isSubmitClick
		);
		//For upward hierarchy------->
		if (this.treeService.merchantAccID.getValue()) {
			this.setBizId = false;
			this.addBtn = false;
			this.tooltipMessage = 'Please select a Store to add Profit Center';
			console.log('This is what I get', this.treeService.treeDataUnderStore);
			if (this.treeService.treeDataUnderStore.xMainPCtrID) {
				this.treeService.isParent = true;
				this.router.navigate([
					'/dashboard/setup/business/structure/profit-center',
					this.treeService.treeDataUnderStore ? this.treeService.treeDataUnderStore.xMainPCtrID : null
				]);
			}
		}
		if (this.treeService.terminalID.getValue()) {
			this.setBizId = false;
			this.addBtn = false;
			this.tooltipMessage = 'Please select a Store to add Profit Center';
			console.log('This is what I get', this.treeService.treeDataUnderStore);
			if (this.treeService.treeDataUnderStore.xMainPCtrID) {
				this.treeService.isParent = true;
				this.router.navigate([
					'/dashboard/setup/business/structure/profit-center',
					this.treeService.treeDataUnderStore ? this.treeService.treeDataUnderStore.xMainPCtrID : null
				]);
			}
		}
		if (this.treeService.periphID.getValue()) {
			this.setBizId = false;
			this.addBtn = false;
			this.tooltipMessage = 'Please select a Store to add Profit Center';
			console.log('This is what I need ===========>', this.treeService.parentTerminal);
			if (this.treeService.parentTerminal.xMainPCtrID) {
				this.treeService.isParent = true;
				this.router.navigate([
					'/dashboard/setup/business/structure/profit-center',
					this.treeService.parentTerminal ? this.treeService.parentTerminal.xMainPCtrID : null
				]);
			}
		}
		//End of upward hierarchy------->
		//For self------>
		if (this.treeService.profitCenterID.getValue()) {
			this.setBizId = false;
			this.router.navigate(['/dashboard/setup/business/structure/profit-center', this.treeService.profitCenterID.getValue()]);
		}
		// End profit-centerelf------->
		//For downward hierarchy------->
		if (this.treeService.businessID.getValue()) {
			this.setBizId = false;
			this.addBtn = false;
			this.tooltipMessage = 'Please select a Store to add Profit Center';
			console.log('here');
			// let tempObj = {
			//     business: "current",
			//     chain: "list",
			//     region: "list",
			//     property: "list",
			//     store: "list",
			//     pctr: "list",
			//     meracct: 'list',
			//     terminal: 'list',
			//     periph: 'list',
			// }
			// this.businessService.setTabStructureNames(tempObj);
		}
		if (this.treeService.chainID.getValue()) {
			this.setBizId = false;
			this.addBtn = false;
			this.tooltipMessage = 'Please select a Store to add Profit Center';
			this.parameters = {
				// xTypeTag: 'struct.property',
				struct_type: 'chain',
				structID: this.treeService.chainID.getValue()
			};
		}
		if (this.treeService.regionID.getValue()) {
			this.setBizId = false;
			this.addBtn = false;
			this.tooltipMessage = 'Please select a Store to add Profit Center';
			this.parameters = {
				// xTypeTag: 'struct.property',
				struct_type: 'region',
				structID: this.treeService.regionID.getValue()
			};
		}
		if (this.treeService.propertyID.getValue()) {
			this.setBizId = false;
			this.addBtn = false;
			this.tooltipMessage = 'Please select a Store to add Profit Center';
			this.parameters = {
				// xTypeTag: 'struct.property',
				struct_type: 'property',
				structID: this.treeService.propertyID.getValue()
			};
		}
		if (this.treeService.storeID.getValue()) {
			this.setBizId = false;
			this.addBtn = true;
			this.tooltipMessage = 'Add Profit Center';
			this.parameters = {
				// xTypeTag: 'struct.property',
				xStoreID: this.treeService.storeID.getValue()
			};
		} else {
			if (this.setBizId) {
				this.addBtn = false;
				this.tooltipMessage = 'Please select a Store to add Profit Center';
				this.treeService.setId(this.businessService.businessID.getValue(), 'business');
			}
		}
		//End of downward hierarchy------->
		this.parameters.grid = true;	
		this.setGridProperties();
	}

	setBreadCrumbValue(): void {
		const breadCrumb: any = {};
		breadCrumb.root = 'Setup';
		breadCrumb.child = 'Structure';
		breadCrumb.subChild = 'Profit Center';
		breadCrumb.subChildLink = null;
		breadCrumb.grandChild = 'Profit Centers';
		breadCrumb.rootList = [];
		this.breadcrumbService.setBreadCrumb(breadCrumb);
	}

	setGridProperties() {
		this.storeValue = 'SetupStructureProfitCenterStore';
		this.storeObject = this.setupStructureProfitCenterStore;
		// this.attributes = [
		//     { header: 'Active', mapTo: 'xStatus', width: '10%' },
		//     { header: 'Name', mapTo: 'xName', width: '20%' },
		//     { header: 'TypeTag', mapTo: 'xTypeTag', width: '20%' },
		//     { header: 'Tag', mapTo: 'xTag', width: '20%' },
		//     // { header: 'Medium', mapTo: 'xMdmTag', width: '10%' },
		//     // { header: 'SoP', mapTo: 'xStrVal', width: '10%' },
		//     { header: 'Notes', mapTo: 'xNotes', width: '20%' },
		//     { header: 'Actions', mapTo: '', width: '10%'}
		// ];
		const editLink = '/dashboard/setup/business/structure/profit-center';
		this.action = [
			{ type: 'view', visible: true, text: 'Details', icon: 'fa fa-eye', action: 'emit' }
			// { type: 'edit', visible: true, text: 'Edit', icon: 'fa fa-edit', action: 'url', onClick: editLink },
			// { type: 'delete', visible: true, text: 'Delete', icon: 'fa fa-trash', action: 'func', onClick: 'destroy'}
		];
		if (!this.userHandlerService.userRoles.isBusinessEmployee) {
			this.attributes = [
				// { header: 'Active', mapTo: 'xStatus', width: '5%' },
				{ header: 'Store Name', mapTo: 'xStoreName', width: '30%' },	
				{ header: 'Name', mapTo: 'xName', width: '30%' },
				{ header: 'GMID', mapTo: 'xGMID', width: '15%' },
				{ header: 'GMPW', mapTo: 'xGMPW', width: '15%' },
				// { header: 'Tag', mapTo: 'xTag', width: '10%' },
				// { header: 'Type Tag', mapTo: 'xTypeTag', width: '10%' },
				// { header: 'Medium', mapTo: 'xMdmTag', width: '10%' },
				// { header: 'SoP', mapTo: 'xStrVal', width: '10%' },
				// { header: 'Notes', mapTo: 'xNotes', width: '20%' },
				{ header: 'Actions', mapTo: '', width: '10%' }
			];
			this.action.push(
				{
					type: 'edit',
					visible: true,
					text: 'Edit',
					icon: 'fa fa-edit',
					action: 'url',
					onClick: editLink
				},
				{
					type: 'delete',
					visible: true,
					text: 'Delete',
					icon: 'fa fa-trash',
					action: 'func',
					onClick: 'destroy',
					disabled: !this.userHandlerService.userPerms.canDeleteSetup
				}
			);
		} else if (this.userHandlerService.userRoles.isBusinessEmployee) {
			this.attributes = [
				// { header: 'Active', mapTo: 'xStatus', width: '5%' },
				{ header: 'Store Name', mapTo: 'xStoreName', width: '30%' },	
				{ header: 'Name', mapTo: 'xName', width: '30%' },
				{ header: 'GMID', mapTo: 'xGMID', width: '20%' },
				{ header: 'GMPW', mapTo: 'xGMPW', width: '20%' },
				// { header: 'Tag', mapTo: 'xTag', width: '10%' },
				// { header: 'Type Tag', mapTo: 'xTypeTag', width: '10%' },
				// { header: 'Medium', mapTo: 'xMdmTag', width: '10%' },
				// { header: 'SoP', mapTo: 'xStrVal', width: '10%' },
				// { header: 'Notes', mapTo: 'xNotes', width: '25%' }
			];
		}
	}

	onActionRequest(obj: any) {
		if (obj.act.type === 'view') {
			console.log("I'm here bro", obj);
			this.pctrID = obj.id;
			// this.detailVisible = true;
		}
	}

	onShowDetails(obj: any) {
		this.showDetails = obj;
	}

	viewClosed(visible: boolean) {
		if (!visible) {
			this.pctrID = '';
			this.showDetails = false;
		}
	}

	checkAddIsAllowed() {
		if (this.businessService.businessData.xStructCaps.xHasMulPCtrs) {
			if (this.treeService.storeID.getValue()) {
				console.log('Return false1');
				return false;
			} else {
				return true;
			}
		} else {
			return true;
		}
	}
}
